import ar_AR from '../../ar_AR';

const extend = {
  movies: ' آية',
  tvseries: 'دعاء',
  cartoons: 'اطفال'
};

const ar_RT = {...ar_AR, ...extend};

export default ar_RT;



// WEBPACK FOOTER //
// ./src/locales/dics/ext/art/ar_RT.js